import React, { useEffect, useState } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Events from "./pages/Events";
import Event from "./pages/Event";
import Tickets from "./pages/Tickets";
import Ticket from "./pages/Ticket";
import Billet from "./pages/Billet";
import axiosInstance from "./api/axiosInstance.ts";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Gateway from "./pages/Gateway.tsx";
import useAuthStore from "./store/authStore.ts";
import GoogleMap from "./pages/GoogleMap.tsx";
import { ThemeProvider } from "./components/ThemeProvider.tsx";
import EventsPurchased from "./pages/EventsPurchased.tsx";
import EventsPurchasedTickets from "./pages/EventsPurchasedTickets.tsx";
import OtpScreen from "./pages/OtpScreen.tsx";
import DownLoadPage from "./pages/DownLoadPage.tsx";
import DesktopView from "./components/DesktopView.tsx";
import { setMetaTags } from "./utils/seo.ts";
import {ToastContainer} from "react-toastify";

const username = import.meta.env.VITE_VMS_USERNAME;
const password = import.meta.env.VITE_VMS_PASSWORD;

const queryClient = new QueryClient();

const App: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const disableRightClick = (event: MouseEvent) => event.preventDefault();

    const disableShortcuts = (event: KeyboardEvent) => {
      if (
        event.key === "F12" || // Bloque F12
        (event.ctrlKey &&
          event.shiftKey &&
          ["I", "J", "C", "K"].includes(event.key)) || // Windows: Ctrl + Shift + I/J/C/K
        (event.metaKey &&
          event.altKey &&
          ["I", "J", "C", "K"].includes(event.key)) || // Mac: Cmd + Option + I/J/C/K
        (event.metaKey && event.shiftKey && event.key.toLowerCase() === "c") || // Mac: Shift + Cmd + C
        (event.ctrlKey && event.key === "U") || // Windows: Ctrl + U (View Source)
        (event.metaKey && event.key === "U") // Mac: Cmd + U (View Source)
      ) {
        event.preventDefault();
      }
    };
    if(import.meta.env.MODE !== "development"){
      document.addEventListener("contextmenu", disableRightClick);
      document.addEventListener("keydown", disableShortcuts);
    }
    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableShortcuts);
    };
  }, []);

  useEffect(() => {
    const token = useAuthStore.getState().token;
    /* const getTokenExpired = async () => {
          const isJwtTokenExpired= await getIsJwtTokenExpired();

          if(isJwtTokenExpired) {
              loginUser();
          }
      }*/

    const loginUser = () => {
      if (username && password) {
        const response = axiosInstance.post("/login_check", {
          username,
          password,
        });

        response
            .then((res) => {
              useAuthStore
                  .getState()
                  .setAuthTokens(res?.data?.token, res?.data?.refreshToken);
            })
            .catch((err) => {
              throw new Error(err);
            });
      }
    };

    if (!token) {
      loginUser();
    }
    /*if (token) {
        getTokenExpired();
    } else {

        loginUser();
    }*/
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const setHeaderTags = () => {
      const title = import.meta.env.VITE_VMS_TITLE;
      const description = import.meta.env.VITE_VMS_DESCRIPTION;
      const ogTitle = import.meta.env.VITE_VMS_OG_TITLE;
      const ogDescription = import.meta.env.VITE_VMS_OG_DESCRIPTION;
      const ogImage = import.meta.env.VITE_VMS_OG_IMAGE;
      const ogUrl = import.meta.env.VITE_VMS_OG_URL;
      const ogType = import.meta.env.VITE_VMS_OG_TYPE;
      const ogLocale = import.meta.env.VITE_VMS_OG_LOCALE;
      const ogSiteName = import.meta.env.VITE_VMS_OG_SITE_NAME;

      const ogFavicon = import.meta.env.VITE_VMS_FAVICON;

      setMetaTags(
        title,
        description,
        ogTitle,
        ogDescription,
        ogImage,
        ogUrl,
        ogType,
        ogLocale,
        ogSiteName,
        ogFavicon
      );
    };

    setHeaderTags();
  }, []);

  if (!isMobile) {
    return <DesktopView />;
  }

  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gateway" element={<Gateway />} />
            <Route path="/Events" element={<Events />} />
            <Route
              path="/Events/:categoryReference/:categoryLabel"
              element={<Events />}
            />
            <Route path="/Event/:eventReference" element={<Event />} />
            <Route path="/tickets" element={<Tickets />} />
            <Route path="/google-map" element={<GoogleMap />} />
            <Route
              path="/ticket/:eventReference/:serviceReference"
              element={<Ticket />}
            />
            <Route path="/billet" element={<Billet />} />
            <Route path="/otp" element={<OtpScreen />} />
            <Route path="/download" element={<DownLoadPage />} />

            <Route path="/events-purchased" element={<EventsPurchased />} />
            <Route
              path="/events-purchased-tickets"
              element={<EventsPurchasedTickets />}
            />
          </Routes>
        </Router>
      </QueryClientProvider>
      <ToastContainer />
    </ThemeProvider>
  );
};

export default App;
